import { createAction, props } from '@ngrx/store';
import { Event, EventFilters } from '../../models';
import { PagedOverview } from 'src/app/standalone/models/paged-overview.model';

export const LoadEvents = createAction('[Events] Load Event Items');
export const LoadEventsSuccess = createAction('[Events] Load Event Items Success', props<{ events: Event[] }>());
export const LoadEventsFail = createAction('[Events] Load Event Items Fail', props<{ error: any }>());

export const LoadEventsOverview = createAction(
  '[Events] Load Event overview items',
  props<{ take?: number; skip?: number; filters?: EventFilters }>()
);
export const LoadEventsOverviewSuccess = createAction(
  '[Events] Load Event overview items Success',
  props<{ events: PagedOverview<Event> }>()
);
export const LoadEventsOverviewFail = createAction('[Events] Load Event overview items Fail', props<{ error: any }>());

export const LoadMoreEvents = createAction('[Events] Load More Event');
export const LoadMoreEventsSuccess = createAction('[Events] Load More Event Success', props<{ events: PagedOverview<Event> }>());

export const LoadEventById = createAction('[Events] Load Event Item by Id', props<{ id: number; eventDate?: string }>());
export const LoadEventByIdSuccess = createAction('[Events] Load Event Item by Id Success', props<{ item: Event }>());
export const LoadEventByIdFail = createAction('[Events] Load Event Item by Id Fail', props<{ id: number; error: any }>());
